import { FileChangeQItem } from './file-item';
import { ChangeQItem } from './item';
import { ReportLayoutChangeQItem } from './report-layout-item';

export class ChangeQItemHelper {

    static hydrate(
        item: ChangeQItem | FileChangeQItem| ReportLayoutChangeQItem
    ): ChangeQItem {
        switch (item.entity) {
            case 'file': {
                return new FileChangeQItem(item as any);
            }
            case 'reportLayout': {
                return new ReportLayoutChangeQItem(item as any);
            }
            default: {
                return new ChangeQItem(item);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/core/services/sync-up/change-q-item.helper.ts